import * as React from 'react';
import { Grid, Dialog, Typography } from '@material-ui/core';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import UndoButton from '../../../../ui-components/Button/UndoButton';
import { DateComp } from './Details';
import { ActivitySchedule } from '../../../../model/activities';

interface IProps {
    open: boolean;
    onClose:()=>any;
    classes:any;
    confirm:()=>any;
    scheduleToAdd:ActivitySchedule[];
    scheduleToRemove:ActivitySchedule[];
}
export const AlertModified = (props: IProps) => {
    return (
        <Dialog maxWidth={'lg'} open={props.open} onClose={() => props.onClose}>
            <div className={props.classes.alterDatesPopupContainer}>
                <Grid container>
                    <Grid item sm={12} style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Typography variant='h6'>Durata attività modificata</Typography>
                    </Grid>
                    <Grid item sm={12}>
                        {Boolean(props.scheduleToAdd && props.scheduleToAdd.length) && <>
                            <Typography>Verranno aggiunti {props.scheduleToAdd.length} appuntamenti</Typography>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap'
                            }}>
                                {(props.scheduleToAdd || []).map(s => DateComp(s.date))}
                            </div>
                        </>}
                    </Grid>
                    <Grid item sm={12}>
                        {Boolean(props.scheduleToRemove && props.scheduleToRemove.length) && <>
                            <Typography>Verranno rimossi {props.scheduleToRemove.length} appuntamenti</Typography>
                            <div style={{
                                display: 'flex'
                            }}>
                                {props.scheduleToRemove.map(s => DateComp(s.date))}
                            </div>
                        </>}
                    </Grid>
                </Grid>
                <Grid item sm={12} className={props.classes.buttonsContainer}>
                    <ConfirmButton text='Conferma' onClick={props.confirm} />
                    <UndoButton text='Annulla' onClick={props.onClose} />
                </Grid>
            </div>
        </Dialog>
    );
}

